"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeStrategyMatrixQueryState = void 0;
const ramda_1 = require("ramda");
const strategy_matrix_query_params_models_1 = require("./strategy-matrix-query-params.models");
const comparableFields = [
    strategy_matrix_query_params_models_1.StrategyMatrixViewQueryStateField.ProjectId,
    strategy_matrix_query_params_models_1.StrategyMatrixViewQueryStateField.CatalogId,
    strategy_matrix_query_params_models_1.StrategyMatrixViewQueryStateField.ExtendedFilter,
    strategy_matrix_query_params_models_1.StrategyMatrixViewQueryStateField.SelectedAttributes,
    strategy_matrix_query_params_models_1.StrategyMatrixViewQueryStateField.SelectedDisplayTable,
    strategy_matrix_query_params_models_1.StrategyMatrixViewQueryStateField.TerminalNodeId,
];
const hasField = (state, field) => (Object.prototype.hasOwnProperty.call(state, field));
const isSelectedCategoryArray = (value) => Array.isArray(value);
const isCompactSelection = (value) => (Boolean(value)
    && typeof value === 'object'
    && !Array.isArray(value)
    && value.selectAll === true
    && Array.isArray(value.excludedValues));
const normalizeCompactExtendedFilterCategories = (value) => {
    if (!Array.isArray(value))
        return undefined;
    const normalizedCategories = value
        .filter((category) => Boolean(category) && typeof category === 'object' && !Array.isArray(category))
        .map((category) => {
        const typedCategory = category;
        if (typeof typedCategory.id !== 'string')
            return null;
        if (!typedCategory.children)
            return null;
        if (Array.isArray(typedCategory.children)) {
            if (!typedCategory.children.length || !typedCategory.children.every((item) => typeof item === 'string'))
                return null;
            return {
                id: typedCategory.id,
                children: typedCategory.children,
            };
        }
        if (!isCompactSelection(typedCategory.children) || !typedCategory.children.excludedValues.length) {
            return null;
        }
        return {
            id: typedCategory.id,
            children: typedCategory.children,
        };
    })
        .filter((item) => item != null);
    return normalizedCategories.length ? normalizedCategories : undefined;
};
const normalizeExtendedFilter = (value) => {
    if (!value)
        return undefined;
    if (isSelectedCategoryArray(value)) {
        return value.length ? value : undefined;
    }
    if (!isCompactSelection(value))
        return undefined;
    const compactValue = value;
    const normalizedCategories = normalizeCompactExtendedFilterCategories(compactValue.categories);
    if (!compactValue.excludedValues.length && !normalizedCategories) {
        return { selectAll: true, excludedValues: [] };
    }
    return Object.assign({ selectAll: true, excludedValues: compactValue.excludedValues }, (normalizedCategories ? { categories: normalizedCategories } : {}));
};
const normalizeComparableState = (state) => {
    var _a, _b;
    const normalized = {};
    if (state[strategy_matrix_query_params_models_1.StrategyMatrixViewQueryStateField.ProjectId]) {
        normalized[strategy_matrix_query_params_models_1.StrategyMatrixViewQueryStateField.ProjectId] = state[strategy_matrix_query_params_models_1.StrategyMatrixViewQueryStateField.ProjectId];
    }
    if (state[strategy_matrix_query_params_models_1.StrategyMatrixViewQueryStateField.CatalogId]) {
        normalized[strategy_matrix_query_params_models_1.StrategyMatrixViewQueryStateField.CatalogId] = state[strategy_matrix_query_params_models_1.StrategyMatrixViewQueryStateField.CatalogId];
    }
    const normalizedExtendedFilter = normalizeExtendedFilter(state[strategy_matrix_query_params_models_1.StrategyMatrixViewQueryStateField.ExtendedFilter]);
    if (normalizedExtendedFilter) {
        normalized[strategy_matrix_query_params_models_1.StrategyMatrixViewQueryStateField.ExtendedFilter] = normalizedExtendedFilter;
    }
    if ((_a = state[strategy_matrix_query_params_models_1.StrategyMatrixViewQueryStateField.SelectedAttributes]) === null || _a === void 0 ? void 0 : _a.length) {
        normalized[strategy_matrix_query_params_models_1.StrategyMatrixViewQueryStateField.SelectedAttributes] = state[strategy_matrix_query_params_models_1.StrategyMatrixViewQueryStateField.SelectedAttributes];
    }
    if ((_b = state[strategy_matrix_query_params_models_1.StrategyMatrixViewQueryStateField.SelectedDisplayTable]) === null || _b === void 0 ? void 0 : _b.length) {
        normalized[strategy_matrix_query_params_models_1.StrategyMatrixViewQueryStateField.SelectedDisplayTable] = state[strategy_matrix_query_params_models_1.StrategyMatrixViewQueryStateField.SelectedDisplayTable];
    }
    if (state[strategy_matrix_query_params_models_1.StrategyMatrixViewQueryStateField.TerminalNodeId]) {
        normalized[strategy_matrix_query_params_models_1.StrategyMatrixViewQueryStateField.TerminalNodeId] = state[strategy_matrix_query_params_models_1.StrategyMatrixViewQueryStateField.TerminalNodeId];
    }
    return normalized;
};
const normalizeStrategyMatrixQueryState = (state, defaults = {}) => {
    const normalized = {
        [strategy_matrix_query_params_models_1.StrategyMatrixViewQueryStateField.Version]: strategy_matrix_query_params_models_1.STRATEGY_MATRIX_VIEW_QUERY_STATE_VERSION,
    };
    const comparableState = normalizeComparableState(state);
    const comparableDefaults = normalizeComparableState(defaults);
    comparableFields.forEach((field) => {
        if (hasField(comparableState, field) && !(0, ramda_1.equals)(comparableState[field], comparableDefaults[field])) {
            normalized[field] = comparableState[field];
        }
    });
    return Object.keys(normalized).length === 1 ? null : normalized;
};
exports.normalizeStrategyMatrixQueryState = normalizeStrategyMatrixQueryState;
